export default __webpack_public_path__ + "static/media/Nikhil.3ae4da3b.jpg";